import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaSchool, FaBriefcase } from 'react-icons/fa';
import { LiaLaptopSolid } from "react-icons/lia";
import { GiGraduateCap } from "react-icons/gi";
import { IoRocket } from "react-icons/io5";

import ivyImg from "../assets/ivy.jpeg";
import adpImg from "../assets/adp.jpeg";
import modelNImg from "../assets/modeln.png";
import companyImg from "../assets/company.png";
import masterImg from "../assets/master.jpeg";
import alertImg from "../assets/alert.jpeg";


export const Experience = () => {
    return (
      <section id = 'experience'>
        <h1 className='header-skillset'>Professional Journey</h1>
        <VerticalTimeline animate={true}>

        <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Dec 2023 - Present"
            iconStyle={{ background: 'crimson', color: 'white'}}
            icon={<LiaLaptopSolid />}>
                <div className="timeline-content">
                    <img src={alertImg} alt="School" className="timeline-image" />
                    <h3 className="vertical-timeline-element-title">AlertDriving</h3>
                </div>
                <p style = {{fontWeight: 'bold', color: '#838383'}}>Software Engineer III<br/>P9</p>
                <p>
                    <ul>
                        Developed a comprehensive sales management application, P9, leveraging Java 17 and Quarkus for backend operations.
                        <br/>
                        <br/>
                        Instrumental in integrating tools like JDBI, PostgreSQL, and Hasura GraphQL to enhance the sales process from lead generation to contract signing.
                    </ul>
                </p>
            </VerticalTimelineElement>


            <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Aug 2022 - Dec 2023"
            iconStyle={{ background: '	#ffcf86', color: '#fff' }}
            icon={<GiGraduateCap />}>
                <div className="timeline-content">
                    <img src={masterImg} alt="School" className="timeline-image" />
                    <h3 className="vertical-timeline-element-title">University of Southern California</h3>
                </div>
                <p style = {{fontWeight: 'bold', color: '#838383'}}>Teaching Assistant<br/>Department of Computer Science</p>
                <p>
                    <ul>
                    Analysis of Algorithms (CSCI 570) – Design algorithm problems and mentor students
                    </ul>
                </p>
            </VerticalTimelineElement>
            
            <VerticalTimelineElement
                className="vertical-timeline-element--education"
                date="Jan 2021 - Jul 2022"
                iconStyle={{ background: '#F28500', color: 'white'}}
                icon={<LiaLaptopSolid />}>
                    <div className="timeline-content">
                        <img src={ivyImg} alt="School" className="timeline-image" />
                        <h3 className="vertical-timeline-element-title">Ivy Comptech</h3>
                    </div>
                    <p style = {{fontWeight: 'bold', color: '#838383'}}>Senior Software Engineer<br/>Sports Feed Integration</p>
                    <p>
                        <ul>
                        Achieved scalability enhancement by seamlessly configuring Apache Kafka for managing high volume of feed requests
                        <br />
                        <br />
                        Utilized Redis for real-time processing of sports data feeds, aggregating & storing live game statistics for front-end consumption
                        <br />
                        <br />
                        Contributed to the design & implementation of Microservices architecture, improving system modularity & facilitating availability
                        </ul>
                    </p>
            </VerticalTimelineElement>


            <VerticalTimelineElement
                className="vertical-timeline-element--education"
                date="Nov 2019 - Dec 2020"
                iconStyle={{ background: '#0071C5', color: 'white'}}
                icon={<LiaLaptopSolid />}>
                    <div className="timeline-content">
                        <img src={modelNImg} alt="School" className="timeline-image" />
                        <h3 className="vertical-timeline-element-title">Model N</h3>
                    </div>
                    <p style = {{fontWeight: 'bold', color: '#838383'}}>Software Engineer II<br/>Revenue Management for Life Sciences</p>
                    <p>
                        <ul>
                            Spearheaded implementation of Biz Engine - A calculation framework to reuse strategies and compute rebates
                            <br/>
                            <br/>
                            Designed RESTful APIs for the calculation framework utilizing Java and Hibernate, to streamline data access and transactions.
                        </ul>
                    </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Jul 2017 - Nov 2019"
            iconStyle={{ background: 'crimson', color: 'white'}}
            icon={<LiaLaptopSolid />}>
                <div className="timeline-content">
                    <img src={adpImg} alt="School" className="timeline-image" />
                    <h3 className="vertical-timeline-element-title">ADP</h3>
                </div>
                <p style = {{fontWeight: 'bold', color: '#838383'}}>Software Engineer I<br/>North American Tax Engine</p>
                <p>
                    <ul>
                    Played a key role in designing and developing scalable REST APIs using Spring Data REST, focusing on a generic domain model for seamless integration with internal services.
                    <br/>
                    <br/>
                    Integrated a comprehensive tax alert system into the application using Oracle DB, Java & Akka for concurrent processing, and JSP for dynamic web-based notifications.
                    </ul>
                    
                </p>
            </VerticalTimelineElement>
      </VerticalTimeline>
      </section>
    );
  };
  